import { ISectionProductSliderFields } from 'global';
import { useContentful } from 'modules/content-cms/components/context';
import RibbonText from 'modules/content-cms/components/ribbon-text';
import CollectionSectionBestseller from 'modules/landingpage/components/collection-section-bestseller';
import React from 'react';
import ContentContainer from '../components/content-container';
import Title from '../components/title';

interface Props extends ISectionProductSliderFields {
  isBlogPost: boolean;
}

const ProductSlider: React.FC<Props> = ({
  title,
  backgroundColor,
  collectionHandle,
  isBlogPost,
  itemSize,
  richTitle,
}) => {
  const { shopifyCollectionMap } = useContentful();

  if (!shopifyCollectionMap[collectionHandle]) {
    return null;
  }

  return (
    <ContentContainer
      backgroundColor={backgroundColor ? backgroundColor : 'white'}
    >
      {richTitle ? (
        <RibbonText text={richTitle} />
      ) : title ? (
        <Title>{title}</Title>
      ) : null}

      <CollectionSectionBestseller
        isBlogPost={isBlogPost}
        collection={collectionHandle}
        staticCollection={shopifyCollectionMap[collectionHandle]}
        itemSize={itemSize}
      />
    </ContentContainer>
  );
};

export default ProductSlider;
